import type { NegotiationRoundV2Dto, SourcingEventV2Dto } from "../../../../autogen/bff-api";

// ADR-033 D6: shopped products pre-select their suppliers' bids (multi-winner).
export const basketBidIds = (
  event: SourcingEventV2Dto,
  finalStageRound: NegotiationRoundV2Dto | null,
): string[] => {
  const stageBasket =
    (finalStageRound ? finalStageRound.selectedProductBids : event.selectedProductBids) ?? [];
  return [...new Set(stageBasket.flatMap((group) => group.bids.flatMap((product) => product.bids)))];
};
